import { loadInputMask } from '@hse-design/core';

const inputMaskMixin = {
  props: {
    /**
     * Маска ввода
     */
    mask: {
      type: [String, Object],
      default: ''
    }
  },
  data() {
    return {
      inputMask: undefined,
      inputMaskType: undefined
    };
  },
  computed: {
    inputMaskOptions() {
      return {
        maskOptions: this.mask
      };
    }
  },
  mounted() {
    this.loadInputMask();
    this.updateInputMask();
  },
  updated() {
    this.updateInputMask();
  },
  beforeDestroy() {
    this.destroyInputMask();
  },
  methods: {
    destroyInputMask() {
      this.inputMask && this.inputMask.onWillUnmount();
    },
    loadInputMask() {
      if (!this.mask) return;
      if (this.inputMaskType) return;
      loadInputMask().then((InputMask) => {
        this.inputMaskType = InputMask;
      });
    },
    getInputMaskOptions() {
      return {
        ...this.inputMaskOptions,
        $inputElement: this.$refs.input
      };
    },
    updateInputMask() {
      if (this.inputMask) {
        this.inputMask.onUpdate(this.getInputMaskOptions());
      }
    }
  },
  watch: {
    inputMaskType() {
      if (!this.inputMaskType) return;
      this.inputMask = new this.inputMaskType(this.inputMaskOptions);
      this.inputMask.onDidMount();
    },
    inputMaskOptions() {
      this.updateInputMask();
    },
    mask() {
      this.loadInputMask();
    }
  }
};

export { inputMaskMixin };
